export const BACKUPS_URL = process.env.REACT_APP_BACKUPS_URL;
export const EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL;
export const DOCS_URL = process.env.REACT_APP_DOCS_URL;
